export default function (me,src) {

  const allow={
    jpg:1, png:1, jpeg:1, bmp:1
  };

  if(!src) {
    return src;
  }

  let ret=src.match(/\.([a-zA-Z]+)$/);
  let isBg=false;
  if(!ret) {
    isBg=src.match(/.*url\([\'\"]*([^\'\"]+)[\'\"]*\).*/);
    if(isBg) {
      ret=isBg[1].match(/\.([a-zA-Z]+)$/);
    }
  }

  return src;
  /*
  if(me.props.appStateStore.webp_support && ret && allow[ret[1]]) {
    return isBg?`url('/webp${isBg[1]}.webp')`:`/webp${src}.webp`;
  } else {
    return src;
  }
  */
}